function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/* eslint semi:            ["error", "never"]*/

/* eslint arrow-parens:    ["error", "as-needed"]*/

/* eslint key-spacing:     ["error", { "afterColon": true, "align": "value" }] */

/* eslint no-multi-spaces: ["error", { exceptions: { "ImportDeclaration": true,
                                       "VariableDeclarator": true  } }] */
import { fetchUserStatus, updateUserStatus } from '@engine/actions/creators/user-status';
import Icon from '@engine/components/presentational/base/icon';
import React from 'react';
import Spinner from '@engine/components/presentational/base/spinner';
import { connect } from 'react-redux';
var ENABLED_USER_ICON = 'ok';
var LOCKED_USER_ICON = 'lock';

var UserEnabled = /*#__PURE__*/function (_React$Component) {
  _inherits(UserEnabled, _React$Component);

  var _super = _createSuper(UserEnabled);

  function UserEnabled() {
    var _this;

    _classCallCheck(this, UserEnabled);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _this.url = function () {
      if (_this.userStatus) {
        return _this.props.disableURL;
      }

      return _this.props.enableURL;
    };

    _this.iconClassNames = function () {
      if (_this.userID === _this.props.currentUserId) {
        return 'text-primary';
      }

      var classNames = '';

      if (_this.userStatus) {
        classNames = 'text-success';
      } else {
        classNames = 'text-danger';
      }

      if (_this.props.canEnable || _this.props.canDisable) {
        classNames += ' cursor-pointer';
      }

      return classNames;
    };

    _this.icon = function () {
      if (_this.userStatus) {
        return ENABLED_USER_ICON;
      }

      return LOCKED_USER_ICON;
    };

    _this.handleClick = function () {
      if (_this.userID === _this.props.currentUserId) {
        return;
      }

      if (!(_this.props.canEnable || _this.props.canDisable)) {
        return;
      }

      _this.props.fetchUserStatus(_this.url(), _this.userID);
    };

    return _this;
  }

  _createClass(UserEnabled, [{
    key: "componentDidMount",
    value:
    /**
     * Component life cycle
     */
    function componentDidMount() {
      this.props.updateUserStatus(this.userID, {
        isEnabled: this.props.initialIsEnabled
      });
    }
    /**
     * Render component
     */

  }, {
    key: "render",
    value: function render() {
      if (this.props.isSaving) {
        return React.createElement(Spinner, {
          size: "tiny",
          color: "refined-blue"
        });
      }

      return React.createElement(Icon, {
        icon: this.icon(),
        handleClick: this.handleClick,
        className: this.iconClassNames()
      });
    }
    /**
     * Computed properties
     */

  }, {
    key: "userID",
    get: function get() {
      return this.props.userId;
    }
  }, {
    key: "userStatus",
    get: function get() {
      return this.props.isEnabled;
    }
    /**
     * Methods
     */

  }]);

  return UserEnabled;
}(React.Component);

export default connect(function (state, ownProps) {
  return {
    isEnabled: state["userStatus-".concat(ownProps.userId)].isEnabled,
    isSaving: state["userStatus-".concat(ownProps.userId)].isSaving
  };
}, {
  fetchUserStatus: fetchUserStatus,
  updateUserStatus: updateUserStatus
})(UserEnabled);